/**
 * Copyright 2022 MobiledgeX, Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const VIEW_MODE = "VIEW_MODE";
export const USER_INFO = 'USER_INFO';
export const SHOW_USER_ROLE = 'SHOW_USER_ROLE';
export const SELECT_ORG = 'SELECT_ORG';
export const LOADING_SPINNER = 'LOADING_SPINNER';
export const ROLE_INFO = 'ROLE_INFO';
export const ALERT_INFO = 'ALERT_INFO';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const REGION_INFO = 'REGION_INFO';
export const SHOW_AUDIT = 'SHOW_AUDIT';
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const PRIVATE_ACCESS_EXIST = 'PRIVATE_ACCESS_EXIST'
export const ORGANIZATION_INFO = 'OrganizationInfo'
export const LOAD_MAIN_PAGE = 'LoadMainPage'
